<template>
  <v-col cols="12">
    <v-form v-model="valid" ref="form" lazy-validation>
      <v-row justify="center">
        <!-- Título centrado -->
        <v-col cols="12" md="5">
          <div class="headline">Configuración personal de paro</div>
        </v-col>
        <v-col cols="12" md="5">
        </v-col>

        <!-- Primera fila: Área y Turno -->
        <v-col cols="12" md="5">
          <v-select
            v-model="alarma.areaSeleccionada"
            :items="areas"
            :disabled="lockAll"
            item-text="nombre"
            item-value="idArea"
            label="Seleccione las Áreas [Opcional]"
            multiple
            chips
          />
        </v-col>
        <v-col cols="12" md="5">
          <v-select
            v-model="alarma.turnoSeleccionado"
            :items="alarma.listaTurnos"
            :disabled="lockAll"
            item-text="nombre"
            item-value="idTurno"
            label="Seleccione los Turnos [Opcional]"
            multiple
            chips
          />
        </v-col>

        <!-- Segunda fila: Máquinas y Tiempo de Alarma -->
        <v-col cols="12" md="5">
          <v-select
            v-model="alarma.maquinasSeleccionadas"
            :items="maquinasIns"
            :disabled="lockAll"
            :item-text="nombreMaquina"
            item-value="idMaquinaIns"
            label="Seleccione las Máquinas [Opcional]"
            multiple
            chips
          />
        </v-col>
        <v-col cols="12" md="5">
          <v-select
            v-model="alarma.tiempoSeleccionado"
            :items="tiempos"
            :disabled="lockAll"
            item-text="text"
            item-value="value"
            label="Tiempo de la Alarma [Opcional]"
            hint="Tiempo que debe tener la máquina de paro para enviar la alerta *Vacío se enviarán siempre"
            persistent-hint
            clearable
          />
        </v-col>

        <!-- Tercera fila: Medios y Tiempo Acumulado -->
        <v-col cols="12" md="5">
          <v-select
            v-model="alarma.medioEnvio"
            :items="[
              { text: 'Whatsapp', value: 1 },
              { text: 'Telegram', value: 2 },
              { text: 'SMS', value: 3 }
            ]"
            :disabled="lockAll"
            label="Seleccione los Medios de Envío [Opcional]"
            hint="Vacío será enviado por todos los medios"
            persistent-hint
            multiple
            chips
          />
        </v-col>
        <v-col cols="12" md="5">
        <v-text-field
            v-model="alarma.tiempoAcumulado"
            :disabled="lockAll"
            label="Tiempo de la Alarma Acumulado en Minutos [Opcional]"
            hint="Tiempo acumulado para enviar alerta *Vacío se enviarán siempre"
            persistent-hint
            clearable
            type="number"
        />
        </v-col>

        <!-- Switch y Botón Guardar al nivel del título -->
        <v-col cols="12" md="9">
            <v-switch
                v-model="alarma.predeterminado"
                label="Predeterminado"
                color="success"
            />
        </v-col>
        <v-col cols="12" md="1">
          <v-switch
            v-model="alarma.activo"
            :disabled="lockAll"
            label="Activo"
            color="success"
          />
        </v-col>
        <v-col cols="12" md="10">
        </v-col>
        <v-col cols="12" md="2">
          	<v-btn color="primary mx-2" @click="confirmarActivacion"> Guardar </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-col>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: 'ConfigurarAlarmaForm',
  props: {
    currentItem: Object
  },
  data() {
    return {
      mensajeErrorAlarma: "",
      alarma: {
        areaSeleccionada: [],
        turnoSeleccionado: [],
        listaTurnos: [],
        maquinasSeleccionadas: [],
        tiempoSeleccionado: null,
        tiempoAcumulado: null,
        medioEnvio: [],
        activo: true,
        predeterminado: null
      },
      areas: [],
      maquinasIns: [],
      tiempos: [
        { text: '10 min', value: 1 },
        { text: '30 min', value: 2 },
        { text: '60 min', value: 3 },
        { text: '2 hrs', value: 4 }
      ]
    };
  },
  computed: {
    ...mapState(['desconocidos', 'desconocidosIds', 'nombreEmpresa']),
    lockAll() {
      return this.alarma.predeterminado;
    }
  },
  created() {
    // precarga de áreas y máquinas
    this.cargarAreas();
    this.cargarMaquinas();
    this.onUsuarioChange();
    this.cargarConfiguracionAlarma();
  },
  methods: {
    onUsuarioChange() {
      axios.get(`/Permisos/TurnosUsuario`)
        .then(resp => {
          this.$set(this.alarma, 'listaTurnos', resp.data);
        })
        .catch(err => {
          console.error(err);
          this.$set(this.alarma, 'listaTurnos', []);
          this.alarma.turnoSeleccionado = null;
        });
    },
    nombreMaquina(maquina) {
      if (!maquina) return '';
      return `[${maquina.nombre}] - ${maquina.marca ?? ''} ${maquina.modelo ?? ''}`;
    },
    cargarAreas() {
      axios.get('/Areas')
        .then(r => this.areas = r.data.filter(a => a.idArea > 1));
    },
    cargarMaquinas() {
      axios.get('/MaquinaInstancias')
        .then(r => this.maquinasIns = r.data);
    },
    cancelarActivacion() {
      this.$emit('cancel');
      this.resetForm();
    },
    confirmarActivacion() {
      this.mensajeErrorAlarma = '';
      if (
        !this.alarma.areaSeleccionada.length &&
        !this.alarma.turnoSeleccionado.length &&
        !this.alarma.maquinasSeleccionadas.length
      ) {
        this.mensajeErrorAlarma = 'Debe seleccionar al menos un Área, Turno o Máquina.';
        return;
      }
      const cfg = {
        idSubSeccion: 4,
        idMedioEnvio: this.alarma.medioEnvio,
        activo: this.alarma.activo,
        mantenimiento: true,
        llamadoMantenimiento: false,
        idAreaEnvio: this.alarma.areaSeleccionada,
        idTurnoSeleccionado: this.alarma.turnoSeleccionado,
        idTiempoSeleccionado: this.alarma.tiempoSeleccionado,
        TiempoAcumuladoMinutos: this.alarma.tiempoAcumulado,
        idMaquinaIns: this.alarma.maquinasSeleccionadas,
        activar: true,
        predeterminado: this.alarma.predeterminado,
        correo: null,
        celular: null,
        condicion: true
      };
      axios.put('/Usuarios/ConfiguracionAdicionalAlertas', cfg)
      .then(() => {
        this.$emit('saved');
        // 2) Volver a cargar la configuración recién guardada
        this.cargarConfiguracionAlarma();
      })
      .catch(() => {
        this.mensajeErrorAlarma = 'Error al guardar la configuración';
      });
    },
    cargarConfiguracionAlarma() {
      axios.get(`/Usuarios/ObtenerConfiguracionAdicionalAlertas`)
        .then(response => {
          const data = response.data;
          this.alarma.areaSeleccionada = data.idAreaEnvio ?? null;
          //this.alarma.usuarioSeleccionado = data.idUsuario ?? null;
          this.alarma.turnoSeleccionado = data.idTurnoSeleccionado ?? null;
          this.alarma.medioEnvio = data.idMedioEnvio ?? null;
          this.alarma.tiempoSeleccionado = null;
          if (data.idTiempoSeleccionado != null) {
            const existeTiempo = this.tiempos.some(t => t.value === data.idTiempoSeleccionado);
            if (existeTiempo) {
              this.alarma.tiempoSeleccionado = data.idTiempoSeleccionado;
            }
          }
          this.alarma.tiempoAcumulado = data.tiempoAcumuladoMinutos;
          this.alarma.activo = data.activo;
          this.alarma.predeterminado = data.predeterminado;
          this.alarma.maquinasSeleccionadas = Array.isArray(data.idMaquinaIns)
          ? data.idMaquinaIns : [];

          // Ahora sí: llamamos getAreas() correctamente
          this.getAreas().then(() => {
            this.onAreaChange().then(() => {
              // Esperamos que usuarios, maquinas y turnos ya estén cargados
              this.onUsuarioChange();
            });
          });
        })
        .catch(() => {
          this.resetModal();
          this.alarma.activo = false;
        });
    },
    resetForm() {
      this.alarma = {
        areaSeleccionada: [],
        turnoSeleccionado: [],
        listaTurnos: [],
        maquinasSeleccionadas: [],
        tiempoSeleccionado: null,
        medioEnvio: [],
        tiempoAcumulado: null,
        activo: true
      };
      this.mensajeErrorAlarma = '';
    }
  }
};
</script>
